import { Utility } from '@app/models/utility';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { RequestApproveDataSource } from './request-approve-datasource';

import { AuthService } from '@app/services/auth.service';
import { Firestore } from '@angular/fire/firestore';

import { RequestApproveSet } from './request-approve-datasource';
import { Define } from '@app/models/define';
import { collection, doc, getDoc, getDocs, query, setDoc, Timestamp, where } from 'firebase/firestore';


@Component({
  selector: 'app-request-approve',
  templateUrl: './request-approve.component.html',
  styleUrls: ['./request-approve.component.css']
})
export class RequestApproveComponent implements OnInit {
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;
  dataSource: RequestApproveDataSource;

  /** Columns displayed in the table. Columns IDs can be added, removed, or reordered. */
  displayedColumns = ['user', 'timeStamp', 'actual', 'request', 'cause', 'approveAction'];


  kind: number;
  kinds = Define.RequestKinds;

  constructor(
    private firestore: Firestore,
    public auth: AuthService
  ) {

  }

  async ngOnInit() {
    await this.update();
  }

  async update() {
    const data = await this.loadRequests();
    this.dataSource = new RequestApproveDataSource(this.auth, this.paginator, this.sort, data);
  }

  async loadRequests() {
    const uid = (await this.auth.getUser()).uid;
    console.log('load request start approver=' + uid);
    const requestQuery = query(
      collection(this.firestore, 'change-request'),
      where('dataVersion', '>=', 2),
      where('approverUid', '==', uid),
      where('state', '==', Define.RequestState.Registered)
    );
    const readDatas = await getDocs(requestQuery);
    const results = new Array<RequestApproveSet>();
    const promises = readDatas.docs.map(async x => {
      console.log(x.data());
      if ( x.data()['dataVersion'] === undefined ) {
        return undefined;
      }
      const requestUserId = x.data()['uid'];
      const requestUserSnap = await getDoc(doc(this.firestore, 'users', requestUserId));
      const requestUserName = (requestUserSnap.data() as Record<string, unknown>)?.['displayName'] as string;
      // 旧仕様では申請後に打刻されたことを考慮してここでもtimeStampコレクションから取得していた。
      // しかし、最早最遅打刻の取捨選択が面倒臭いので、申請時のデータで済ませる。
      const changeStamps =  x.data()['changeStamps'] as Timestamp[];
      // firestoreのchangeStampには日本時間に合わせることで現地時間となるtimestampを記録している。
      const r: RequestApproveSet = {
        docId: x.id,
        targetDate: Utility.convertLocalTimeToJstDate((x.data()['target'] as Timestamp).toDate()),
        userName: requestUserName,
        cause: x.data()['cause'],
        actualTimeStamps: x.data()['actualStamps'],
        changeTimeStamps: changeStamps.map( s => s === null ? null : Utility.convertLocalTimeToJstDate(s.toDate())),
        ejectFlags: x.data()['ejectFlags'],
        docSnapShot: x
      };
      results.push(r);
    });
    await Promise.all(promises);
    return results;
  }

  async onApprove(record: RequestApproveSet, setState: number) {
    console.log('submit');
    const d = record.docSnapShot.data();
    d['state'] = setState;
    await setDoc(doc(this.firestore, 'change-request', record.docId), d
      // {
      //   dataVersion: d.dataVersion,
      //   created: d.created,
      //   target: d.target,
      //   uid: d.uid,
      //   timeStamps: d.timeStamps,
      //   cause: d.cause,
      //   state: d.state,
      //   approverUid: d.approverUid
      // }
    );
    // // Firestoreへのアクセスを減らすため、setが成功しているならローカルで削除してdataSourceを差し替える。
    // record.state = setState;
    // const newSource = new RequestApproveDataSource(this.afStore, this.auth, this.paginator, this.sort);
    // newSource.data = this.dataSource.data.filter( r => r.data.state === Define.RequestState.Registered as number);
    // this.dataSource = newSource;
      // バッジはリアルタイムで増えるし、ローカルで考慮するのが面倒なので更新する。
      await this.update();
  }

  getActualStamp(record: RequestApproveSet): string {
    let actualStampsText = '';
    actualStampsText = '出社:\n';
    actualStampsText += (record.actualTimeStamps[0] ? record.actualTimeStamps[0] + '\n' : '');
    actualStampsText += '退社:\n';
    actualStampsText += (record.actualTimeStamps[1] ? record.actualTimeStamps[1] + '\n' : '');
    actualStampsText += '外出:\n';
    for (let i = 2 ; i <= 8 ; i += 2) {
      actualStampsText += (record.actualTimeStamps[i] ? record.actualTimeStamps[i] + '\n' : '');
    }
    actualStampsText += '戻り:\n';
    for (let i = 3 ; i <= 9 ; i += 2) {
      actualStampsText += (record.actualTimeStamps[i] ? record.actualTimeStamps[i] + '\n' : '');
    }
    return actualStampsText;
  }
  getChangeStamp(record: RequestApproveSet): string {
    const arriveStamps = [record.actualTimeStamps[0]];
    const leaveStamps = [record.actualTimeStamps[1]];
    let temporaryLeaveStamps = [
      record.actualTimeStamps[2],
      record.actualTimeStamps[4],
      record.actualTimeStamps[6],
      record.actualTimeStamps[8]
    ];
    let reenterStamps = [
      record.actualTimeStamps[3],
      record.actualTimeStamps[5],
      record.actualTimeStamps[7],
      record.actualTimeStamps[9]
    ];
    let changeStampsText = '';
    if (record.docSnapShot.data()['dataVersion'] === 2) {
      record.ejectFlags.forEach( (e, index) => {
        if (e) {
          if (index === 0 || index === 1) {
            // 出社・退社
            // 今のところ出社・退社の取消はシステムの仕様上不可能
          } else if (index % 2 === 0) {
            // 外出
            temporaryLeaveStamps[(index - 2) / 2] = '';
          } else if (index % 2 === 1) {
            // 戻り
            reenterStamps[(index - 3) / 2] = '';
          }
        } else if (record.changeTimeStamps[index] !== null) {
          const t = Utility.convertDateToDateMinite(record.changeTimeStamps[index]);
          if (index === 0) {
            // 出社
            arriveStamps.splice(0, 1, t);
          } else if (index === 1) {
            // 退社
            leaveStamps.splice(0, 1, t);
          } else if (index % 2 === 0) {
            // 外出
            temporaryLeaveStamps[(index - 2) / 2] = t;
          } else if (index % 2 === 1) {
            // 戻り
            reenterStamps[(index - 3) / 2] = t;
          }
        }
      });
      temporaryLeaveStamps.sort();
      reenterStamps.sort();
      changeStampsText = '出社:\n';
      changeStampsText += (arriveStamps[0] ? arriveStamps[0] + '\n' : '');
      changeStampsText += '退社:\n';
      changeStampsText += (leaveStamps[0] ? leaveStamps[0] + '\n' : '');
      changeStampsText += '外出:\n';
      for (const stamp of temporaryLeaveStamps) {
        changeStampsText += (stamp ? stamp + '\n' : '');
      }
      changeStampsText += '戻り:\n';
      for (const stamp of reenterStamps) {
        changeStampsText += (stamp ? stamp + '\n' : '');
      }
    } else if (record.docSnapShot.data()['dataVersion'] === 3) {
      // 取消
      record.ejectFlags.forEach( (e, index) => {
        if (e) {
          if (index === 0 || index === 1) {
            // 出社・退社
            // 今のところ出社・退社の取消はシステムの仕様上不可能
          } else if (index % 2 === 0) {
            // 外出
            temporaryLeaveStamps[(index - 2) / 2] = '';
          } else if (index % 2 === 1) {
            // 戻り
            reenterStamps[(index - 3) / 2] = '';
          }
        }
      });
      record.changeTimeStamps.forEach( (elm, index) => {
        let t = '';
        if (elm !== null) {
          t = Utility.convertDateToDateMinite(elm);
          if (index === 0) {
            // 出社
            arriveStamps.splice(0, 1, t);
          } else if (index === 1) {
            // 退社
            leaveStamps.splice(0, 1, t);
          } else if (index % 2 === 0) {
            // 外出
            temporaryLeaveStamps.push(t);
          } else if (index % 2 === 1) {
            // 戻り
            reenterStamps.push(t);
          }
        }
      });
      // 空文字列除去
      temporaryLeaveStamps = temporaryLeaveStamps.filter(val => val);
      reenterStamps = reenterStamps.filter(val => val);
      // 0埋めしてるので辞書順ソートでOK
      temporaryLeaveStamps.sort();
      reenterStamps.sort();
      changeStampsText = '出社:\n';
      changeStampsText += (arriveStamps[0] ? arriveStamps[0] + '\n' : '');
      changeStampsText += '退社:\n';
      changeStampsText += (leaveStamps[0] ? leaveStamps[0] + '\n' : '');
      changeStampsText += '外出:\n';
      for (const stamp of temporaryLeaveStamps) {
        changeStampsText += (stamp ? stamp + '\n' : '');
      }
      changeStampsText += '戻り:\n';
      for (const stamp of reenterStamps) {
        changeStampsText += (stamp ? stamp + '\n' : '');
      }
    }
    return changeStampsText;
  }
}
